var render = function render(_c,_vm){return _c('div',{staticClass:"mr-1 product-class"},[_c('img',{staticClass:"product-class-icon",attrs:{"aria-hidden":"","src":_vm.props.pClass.iconSource,"alt":_vm.props.pClass.name,"title":_vm.props.pClass.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }